import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';

import {
  CheckMark,
  Expires,
  CloseIcon,
  UnavailableIcon,
  Warning,
} from 'components/svg';

import {
  Wrapper,
  Icon,
  ContentPromo,
  CloseButton,
  ContentText,
  ContentAction,
  Container,
} from './Banner.styled';

import colors from 'styles/colors';
import { PROMO_CODE_ID } from './Constants';

export const bannerType = {
  promoApplied: {
    colorClose: colors.primary.ocean,
    colorCloseMobile: colors.primary.ice,
    background: colors.functional.green,
    fontcolor: colors.functional.green,
    icon: <CheckMark color={colors.primary.ice} />,
    showClose: true,
  },
  promoExpires: {
    colorClose: colors.primary.ocean,
    colorCloseMobile: colors.primary.ice,
    background: colors.secondary.magentaDeep,
    fontcolor: colors.secondary.magentaDeep,
    icon: <Expires color={colors.primary.ice} />,
    showClose: true,
  },
  promoSoldOut: {
    colorClose: colors.primary.ocean,
    colorCloseMobile: colors.functional.darkGrey,
    background: colors.functional.gold,
    fontcolor: colors.functional.darkGold,
    icon: <UnavailableIcon />,
    showClose: true,
  },
  promoCasino: {
    colorClose: colors.primary.ocean,
    colorCloseMobile: colors.primary.ice,
    background: colors.secondary.gold,
    fontcolor: colors.secondary.goldBold,
    icon: <CheckMark color={colors.primary.ice} />,
    showClose: false,
  },
  promoError: {
    colorClose: colors.primary.ocean,
    colorCloseMobile: colors.primary.ice,
    background: colors.functional.errorRed,
    fontcolor: colors.functional.errorRed,
    icon: <Warning color={colors.primary.ice} />,
    showClose: true,
  },
};

function Banner({ type, onClose, titleBanner, contentBanner, actionBanner }) {
  const { isMobile } = useContext(CruiseSelectionContext);

  const {
    colorClose,
    colorCloseMobile,
    background,
    fontcolor,
    icon,
    showClose,
  } = bannerType[type] || bannerType['promoExpires'];

  const getColor = () => (isMobile ? colorCloseMobile : colorClose);

  return (
    <Container>
      <Wrapper id={PROMO_CODE_ID} $background={background}>
        <>
          <Icon background>
            {icon}
            {isMobile && titleBanner}
            {isMobile && showClose && (
              <CloseButton onClick={onClose} type="button">
                <CloseIcon color={getColor()} />
              </CloseButton>
            )}
          </Icon>
          <ContentPromo $color={fontcolor}>
            <ContentText action={actionBanner ? 1 : 0}>
              {!isMobile && titleBanner}
              {contentBanner}
            </ContentText>
            {actionBanner ? <ContentAction>{actionBanner}</ContentAction> : ''}
          </ContentPromo>
          {!isMobile && showClose && (
            <CloseButton onClick={onClose} type="button">
              <CloseIcon color={getColor()} />
            </CloseButton>
          )}
        </>
      </Wrapper>
    </Container>
  );
}

Banner.propTypes = {
  type: PropTypes.oneOf(Object.keys(bannerType)).isRequired,
  onClose: PropTypes.func,
  titleBanner: PropTypes.any,
  contentBanner: PropTypes.any,
  actionBanner: PropTypes.any,
};

Banner.defaultProps = {
  type: 'promoExpires',
};

export default Banner;
